// extracted by mini-css-extract-plugin
export default {"root":"achievements_root__RSLew","suptitle":"achievements_suptitle__E-Rks"};